export const MODULE_SETTINGS_PATH = "/settings-menu/module-settings";
